// @ts-nocheck
export const textColor = {
    primaryColor :"#FF5C39", // orange
    dark:"#000",
    light:'#fff',
    secondaryColor :"#F8F8F8", //grey color
    borderColor:"#C5C9CD",
    fontColor :"#3B3B3B", // lightGrey
    primaryFont : "#EF233C"

}